
import Vue from 'vue'
import JcdcTitleBar from '@/components/jcdc/JcdcTitleBar.vue'
import JcdcUtilityMenu from '@/components/jcdc/JcdcUtilityMenu.vue'
import { links, userInfo } from '@/util/navUtilities'
import { VAppBar, VCol } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcBrandBar',
  components: {
    JcdcTitleBar,
    JcdcUtilityMenu,
    VAppBar,
    VCol,
  },
  props: {
    // Title Bar
    appTitle: { type: String, required: true },
    appSubtitle: { type: String, required: true },
    extHomeUrl: { type: String, default: undefined },
    appEnvironment: { type: String, required: true },
    // Utility Menu
    userInfo: {
      type: Object as () => userInfo,
      default: undefined,
    },
    utilityList: {
      type: Array as () => Array<links>,
      default: (): [] => [],
    },
  },
  methods: {
    linkClick(event) {
      this.$emit(`${event}-click`, event)
    },
  },
})
